import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "ui/MDBox";
import MDTypography from "ui/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import authorsTableData from "layouts/Funds-management/data";
import { useEffect, useState, useRef } from "react";
import Notification from "examples/Notifications";
import { AddButton } from "layouts/common/buttons";
import fundsServices from "services/funds-services";

const FundsManagement = () => {
    const [funds, setFunds] = useState([]);
    const [notification, setNotification] = useState(null);
    const [selectedFunds, setSelectedFunds] = useState([]);

    useEffect(() => {
        getFunds();
    }, []);

    const getFunds = async () => {
        const fundsData = await fundsServices.getAll();
        if (fundsData.success && fundsData.funds) {
            setFunds(fundsData.funds);
            setSelectedFunds(fundsData.funds);
        }
    };


    const { columns, rows } = authorsTableData(selectedFunds, setNotification);

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info"
                                display="flex" justifyContent="space-between" alignItems="center">
                                <MDTypography variant="h6" color="white"> Funds </MDTypography>
                                <MDBox display="flex" alignItems="center" justifyContent="space-between" >
                                    <AddButton link="/funds/create" />
                                </MDBox>
                            </MDBox>

                            <Notification notification={notification} setNotification={setNotification} />
                            <MDBox pt={3}>
                                <DataTable table={{ columns, rows }} isSorted={true} entriesPerPage={false} showTotalEntries={false} noEndBorder />
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
};

export default FundsManagement;